<template>
  <div class="min-h-screen bg-black text-white font-sans selection:bg-purple-500 selection:text-white overflow-x-hidden">
    <!-- Background -->
    <div class="fixed inset-0 z-0 pointer-events-none">
      <div class="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-purple-900/20 rounded-full blur-[128px]" />
      <div class="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] bg-pink-900/20 rounded-full blur-[128px]" />
    </div>

    <!-- Content -->
    <main class="relative z-10 max-w-3xl mx-auto px-6 py-20 md:py-32">

      <!-- Back link -->
      <NuxtLink
        to="/"
        class="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-white transition-colors mb-12"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
        Back to games
      </NuxtLink>

      <!-- Heading -->
      <h1 class="text-5xl md:text-7xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-br from-white via-gray-200 to-gray-500 mb-8">
        About Vibe Games
      </h1>

      <!-- Body -->
      <div class="space-y-8 text-gray-300 text-lg leading-relaxed">
        <p>
          Vibe Games is a self-bootstrapped game studio by Aaron Botello, focused on prototyping games built around strong mechanics and social play. The goal is simple: create games that make game night feel fresh, memorable, and easy to share with other people.
        </p>
        <p>
          This work is for the game night masters who love bringing new experiences to the table, and for the friends who just want to jump in and have fun together. While the ideas may start as prototypes, the bigger vision is to explore games that are playful, repeatable, and best when people are in the same room reacting together.
        </p>

        <!-- Under Construction -->
        <div class="border-t border-gray-800 pt-10 mt-10 text-center">
          <div class="text-5xl mb-4">🚧</div>
          <p class="text-xl font-bold text-white mb-2">More coming soon</p>
          <p class="text-gray-500">This page is under construction.</p>
        </div>
      </div>

    </main>

    <!-- Footer -->
    <footer class="relative z-10 border-t border-gray-900 py-6 text-center text-xs text-gray-600">
      © {{ new Date().getFullYear() }} Vibe Labs. All rights reserved.
    </footer>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()

const aboutTitle = 'About Vibe Games'
const aboutDescription = 'Vibe Games is a self-bootstrapped game studio focused on social party games that make game night fresh, memorable, and easy to share.'

useHead({
  link: [
    { rel: 'canonical', href: `${config.public.siteUrl}/about` }
  ]
})

useSeoMeta({
  title: aboutTitle,
  description: aboutDescription,
  ogType: 'website',
  ogTitle: aboutTitle,
  ogDescription: aboutDescription,
  ogUrl: `${config.public.siteUrl}/about`,
})
</script>
